import tw from 'tailwind-styled-components'

export const CareAppointmentManagerContainer = tw.div`
    py-10
    relative
    max-w-screen-2xl
    m-auto
`
